import { Pane, Text } from '@leverege/ui-elements';
import React from 'react';
import S from './NodeRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DefaultNodeRenderer(props) {
  const {
    data,
    preCmp: PreCmp,
    postCmp: PostCmp
  } = props;
  const {
    title
  } = data;
  const titleChildren = [];
  title?.split('/').forEach((piece, index, arr) => {
    titleChildren.push(`${piece}${index !== arr.length - 1 ? '/' : ''}`, /*#__PURE__*/_jsx("wbr", {}));
  });
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:rowMCenter",
    children: [PreCmp ? /*#__PURE__*/_jsx(PreCmp, {
      ...props
    }) : null, /*#__PURE__*/_jsx(Text, {
      className: S.title,
      children: titleChildren
    }), PostCmp ? /*#__PURE__*/_jsx(PostCmp, {
      ...props
    }) : null]
  });
}